import { Fragment } from 'react';
import { useMatch } from 'react-router';

import { DefaultLayout } from 'modules/layout/components/DefautLayout';
import { TopBannerHeightProvider } from 'modules/layout/components/TopBannerHeightProvider';
import { authRoutesConfig } from 'domains/auth/routes';

import { Initializer } from './components/Initializer';
import { RedirectHandler } from './components/RedirectHandler';
import { Routes } from './Routes';

export const AppRouter = () => {
  const isAuthPage = Boolean(useMatch(authRoutesConfig.auth.path));

  const RoutesWrapper = isAuthPage ? Fragment : DefaultLayout;

  return (
    <>
      <Initializer />
      <RedirectHandler />
      <TopBannerHeightProvider>
        <RoutesWrapper>
          <Routes />
        </RoutesWrapper>
      </TopBannerHeightProvider>
    </>
  );
};
